import { render, staticRenderFns } from "./PrecisionMarketingDataTable.vue?vue&type=template&id=9749493c&scoped=true"
import script from "./PrecisionMarketingDataTable.vue?vue&type=script&lang=js"
export * from "./PrecisionMarketingDataTable.vue?vue&type=script&lang=js"
import style0 from "./PrecisionMarketingDataTable.vue?vue&type=style&index=0&id=9749493c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9749493c",
  null
  
)

export default component.exports